import { render, staticRenderFns } from "./AccountManualIndex.vue?vue&type=template&id=524f27ab&"
import script from "./AccountManualIndex.vue?vue&type=script&lang=js&"
export * from "./AccountManualIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports